module.exports = __webpack_public_path__ + "static/media/true_sight.6169af3c.png";